/**
 * Detect when you scroll out of a particular element or move your mouse off screen and then execute a callback
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/events/off/off.js";

export default (observe, callback, timeout) => {
	if (observe.length) {
		setTimeout(() => {

			// intersection observer
			let intersected = false;
			const body = $("body"),
				done = () => {
					observe.each(function () {
						observer.unobserve(this);
					});
					body.off("mouseleave", done);
					callback();
				},
				observer = new IntersectionObserver(entries => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							intersected = true;
						} else if (intersected) {
							done();
						}
					});
				});
			observe.each(function () {
				observer.observe(this);
			});

			// when the mouse leaves the window
			body.one("mouseleave", done);
		}, timeout || 0);
	}
};
